import userRoutes from './user.routes';

import orderHistoryController from './controllers/order.history.controller';
import orderHistoryTimeframeController from './controllers/order.history.timeframe.controller';
import orderHistoryPaginationController from './controllers/order.history.pagination.controller';
import registerController from './controllers/register.controller';
import accountPasswordController from './controllers/account.password.controller';
import passwordInputController from './controllers/password.input.controller';
import editReservationController from './controllers/editReservation.controller';

import orderHistoryComponent from './components/order.history.component';
import orderHistoryTimeframeComponent from './components/order.history.timeframe.component';
import orderHistoryPaginationComponent from './components/order.history.pagination.component';
import registerComponent from './components/register.component';
import accountPasswordComponent from './components/account.password.component';
import appPasswordComponent from './components/app.setPassword.component';
import passwordInputComponent from './components/password.input.component';
import editReservationComponent from './components/editReservation.component';

import userService from './services/user.service';
import authenticateApiService from './services/authenticate.api.service';

let userModule = angular.module('spabooker.user', [])
    .config(userRoutes)

    .controller('orderHistoryController', orderHistoryController)
    .controller('orderHistoryTimeframeController', orderHistoryTimeframeController)
    .controller('orderHistoryPaginationController', orderHistoryPaginationController)
    .controller('registerController', registerController)
    .controller('accountPasswordController', accountPasswordController)
    .controller('passwordInputController', passwordInputController)
    .controller('editReservationController', editReservationController)

    .component('orderHistory', orderHistoryComponent)
    .component('orderHistoryTimeframe', orderHistoryTimeframeComponent)
    .component('orderHistoryPagination', orderHistoryPaginationComponent)
    .component('register', registerComponent)
    .component('accountPassword', accountPasswordComponent)
    .component('appPassword', appPasswordComponent)
    .component('passwordInput', passwordInputComponent)
    .component('editReservation', editReservationComponent)

    .factory('userService', userService)
    .factory('authenticateApi', authenticateApiService)
    ;
export default userModule.name;



// WEBPACK FOOTER //
// ./frontend/storefront/app/modules/user/index.js